import { render, staticRenderFns } from "./CallTemplates.vue?vue&type=template&id=7455504c&"
import script from "./CallTemplates.vue?vue&type=script&lang=ts&"
export * from "./CallTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports